import React, { useContext, cloneElement } from 'react';
import { bool, string, func, node } from 'prop-types';
import cx from 'classnames';
import useStyles from 'hooks/useStyles';

import { CheckIcon } from '@snapask/common-components';

import ApplicationContext from 'components/ApplicationContext';
import ContextStore from 'utils/createContext';

import styles from './DropdownItem.scss';

function DropdownItem({
  className,
  isSelected,
  isDisabled,
  onClick,
  icon,
  children,
}) {
  useStyles(styles);
  const {
    screenWidth: { isMobile },
  } = useContext(ApplicationContext);
  const { toggleDropdown } = useContext(ContextStore);

  const notClickable = isSelected || isDisabled;

  const handleClick = e => {
    if (notClickable) return;
    if (typeof onClick === 'function') {
      onClick(e);
    }
    toggleDropdown();
  };

  return (
    <div
      className={cx(styles.root, styles.dropdownItem, className, {
        [styles.selectedDropdownItem]: isSelected,
        [styles.disabledDropdownItem]: isDisabled,
      })}
      onClick={handleClick}
    >
      {icon &&
        cloneElement(icon, {
          className: styles.icon,
        })}
      {children}
      {isSelected && (
        <CheckIcon
          className={styles.selectedCheckIcon}
          width={isMobile ? 24 : 20}
          height={isMobile ? 24 : 20}
        />
      )}
    </div>
  );
}

DropdownItem.propTypes = {
  children: node.isRequired,
  icon: node,
  className: string,
  onClick: func,
  isSelected: bool,
  isDisabled: bool,
};

DropdownItem.defaultProps = {
  className: '',
  icon: undefined,
  onClick: () => {},
  isSelected: false,
  isDisabled: false,
};

export default DropdownItem;
